<template>
  <div class="user_container">
    <div id="prdDom">
      <div class="log">
        <img src="@/assets/card/3.png" alt="" />
        <p>惠州雷士光电科技有限公司文件</p>
      </div>
      <div class="user_form">
        <p>《{{ userinfo.title }}》</p>
        <van-form>
          <van-field
            v-model="userinfo.nominee"
            name="提名人"
            label="提名人"
            input-align="right"
            :rules="[{ required: true, message: '请填写提名人' }]"
            :readonly="disabledBtn?.includes(true) ? false : true"
          />
          <!-- <van-field
            v-model="userinfo.depament"
            name="提名人部门"
            label="提名人部门"
            input-align="right"
          /> -->
          <van-field
            v-model="userinfo.nominDeptStr"
            name="提名人部门"
            label="提名人部门"
            input-align="right"
            :rules="[{ required: true, message: '请选择提名人部门' }]"
            @focus="changeDepament"
            readonly
          />
          <!-- <div>
            <span>提名人部门</span>
            <el-select v-model="userinfo.nominDept" filterable>
              <el-option
                v-for="item in columns"
                :key="item.id"
                :label="item.departmentName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div> -->
          <van-field name="radio" label="提名类型" input-align="right" readonly>
            <template #input>
              <van-radio-group
                v-model="userinfo.nominType"
                direction="horizontal"
                :disabled="disabledBtn?.includes(true) ? false : true"
              >
                <van-radio :name="1" shape="square">个人</van-radio>
                <van-radio :name="2" shape="square">团队</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model="userinfo.nominated"
            name="被提名人/团队/项目"
            label="被提名人/团队/项目"
            input-align="right"
            label-width="150"
            :readonly="disabledBtn?.includes(true) ? false : true"
          />
        </van-form>
      </div>
      <div class="user_one">
        <p class="title">提报事迹描述( 500-1000字、图文并茂更佳 )</p>
        <div class="concent">
          事迹包含：事件背景、任务目标、所采取的行动、取得的结果。要清晰地阐明缘由，所遇到的挑战和面临的机遇，采取怎样的行动确保成功，取得了怎样的积极结果，产生了怎样的影响（对我们的业务，员工及其他利益相关者和社会的影响等）
        </div>
      </div>
      <div class="user_two">
        <p class="title">成果概述</p>
        <el-input
          v-model="userinfo.achievement"
          placeholder="请输入成果概述"
          type="textarea"
          :readonly="disabledBtn?.includes(true) ? false : true"
        ></el-input>
      </div>
      <div class="user_three">
        <p class="title">事迹描述（背景和目标、任务和行动、取得的成功）</p>
        <el-input
          v-model="userinfo.deedRemark"
          placeholder="请输入事迹描述"
          type="textarea"
          :readonly="disabledBtn?.includes(true) ? false : true"
        ></el-input>
      </div>
      <div class="user_checkout">
        <p class="title">提名标准</p>
        <div>
          <van-radio-group
            v-model="userinfo.nominStandard"
            :readonly="readonly"
            v-for="(item, ind) in columnsNate"
            :key="ind"
            :disabled="disabledBtn?.includes(true) ? false : true"
          >
            <van-radio :name="item.value" shape="square">{{
              item.text
            }}</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="user_footer">
        <p class="title">提名人推荐语</p>
        <el-input
          v-model="userinfo.recommendation"
          placeholder="请输入提名人推荐语"
          type="textarea"
          :readonly="disabledBtn?.includes(true) ? false : true"
        ></el-input>
      </div>
      <el-form class="from">
        <el-form-item label="报名表" class="download" v-if="!userinfo.close">
          <div>
            <span @click="onDownPpt">
              <img src="@/assets/medal/down.png" alt="" />下载ppt模板</span
            >
            <span @click="onDownExcel">
              <img src="@/assets/medal/down.png" alt="" />下载excel模板</span
            >
          </div>
        </el-form-item>
        <el-form-item label="导入文件（文件大小不能大于20MB）" class="leading">
          <br />
          <div>
            <van-uploader
              :max-count="1"
              :after-read="afterOne"
              accept=".ppt,.pptx,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              v-if="!userinfo.close"
              :max-size="20480 * 1024"
            >
              <van-button icon="plus" type="primary">导入PPT文件</van-button>
            </van-uploader>
            <div
              class="leadingSpan"
              v-for="item in fileListOne"
              :key="item.name"
            >
              <span href="" class="a" @click="lookPPT">{{ item.name }}</span
              ><van-icon
                name="close"
                @click="closeFileOne"
                v-if="!userinfo.close"
              />
              <el-progress v-if="flagPpt" :percentage="70" />
            </div>
          </div>
          <div>
            <van-uploader
              :max-count="1"
              :after-read="afterTwo"
              accept=".xlsx,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              v-if="!userinfo.close"
              :max-size="20480 * 1024"
            >
              <van-button icon="plus" type="primary">导入excel文件</van-button>
            </van-uploader>
            <div
              class="leadingSpan"
              v-for="item in fileListTwo"
              :key="item.name"
            >
              <span href="" class="a" @click="lookExcel">{{ item.name }}</span
              ><van-icon
                name="close"
                @click="closeFileTwo"
                v-if="!userinfo.close"
              />
              <el-progress v-if="flagExcel" :percentage="70" />
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="container_item" v-if="userinfo.approveList">
        <div class="title">
          <div class="title_txt">审批流程</div>
        </div>
        <div>
          <!-- <div class="handle" v-for="(approve,index) in userinfo.approveList" :key="approve.id">
            <div class="handleDiv">
              <img
                src="@/assets/car/handle.png"
                alt=""
                srcset=""
                style="width: 27px; height: 27px"
              />
            </div>
            <div class="handleRight">
              <h3 class="rightTitle">{{ index==0?'直属上级审批':"审批人" }}{{ approve.approveState=='2'?' · 已同意':approve.approveState=='3'?' · 已拒绝':'' }}</h3>
              <div class="approver">
                <div class="approverImg">
                  <div class="iconWrapper">
                    <img
                      :src="approve.icon"
                      alt=""
                      srcset=""
                      style="width: 27px; height: 27px"
                    />
                    <span class="elIcon">
                      <i v-if="approve.approveState=='2'" class="el-icon-success" style="color: #267ef0"></i>
                      <i v-if="approve.approveState=='3'" class="el-icon-error" style="color: red"></i>
                    </span>
                  </div>

                  <span class="clr-span">{{approve.approveByName}}</span>
                </div>
                <div class="right">
                  <span v-if="approve.approveState=='2'" style="margin-right:5px;color:#267ef0">已同意</span>
                  <span v-if="approve.approveState=='3'" style="margin-right:5px;color:red">已拒绝</span>
                  <span>{{approve.approveTime}}</span>
                </div>
              </div>
            </div>
          </div> -->
          <div
            class="handle"
            v-for="(approve, index) in userinfo.approveList"
            :key="approve.id"
          >
            <div class="handleDiv">
              <img
                src="@/assets/car/handle.png"
                alt=""
                srcset=""
                style="width: 27px; height: 27px"
              />
            </div>
            <div class="handleRight">
              <h3 class="rightTitle" v-if="approve.nodeName">
                {{ approve.nodeName }}
              </h3>
              <h3 class="rightTitle" v-if="!approve.nodeName">
                {{ index == 0 ? "直属上级审批" : "审批人" }}
              </h3>
              <div class="approver">
                <div class="approverImg">
                  <img
                    :src="approve.icon"
                    alt=""
                    srcset=""
                    style="width: 27px; height: 27px"
                  />
                  <span class="clr-span">{{ approve.approveName }}</span>
                </div>
                <div class="right">
                  <span
                    style="margin-right: 5px"
                    :style="{
                      color:
                        approve.approveState == '通过'
                          ? '#267ef0'
                          : approve.approveState == '驳回'
                          ? 'red'
                          : ''
                    }"
                    v-if="approve.nodeName"
                  >
                    {{ approve.approveState }}
                  </span>
                  <span
                    style="margin-right: 5px"
                    :style="{
                      color:
                        approve.approveState == '2'
                          ? '#267ef0'
                          : approve.approveState == '3'
                          ? 'red'
                          : ''
                    }"
                    v-if="!approve.nodeName"
                  >
                    {{
                      approve.approveState == "2"
                        ? "已同意"
                        : approve.approveState == "3"
                        ? "已拒绝"
                        : ""
                    }}
                  </span>
                  <span>{{ approve.approveTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="menu" @click="down">
      <img src="@/assets/medal/download.png" alt="" />
    </div>
    <div class="foot-btn">
      <van-button style="background: rgba(243, 243, 243, 1)" @click="toUrl"
        >取消</van-button
      >
      <van-button
        style="background: rgba(78, 162, 124, 1); color: #fff"
        @click="submit"
        :disabled="disabledBtn?.includes(true) ? false : true"
        >{{ disabledBtn.includes(true) ? "重新提交" : "已提交" }}</van-button
      >
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
import { downloadExcel } from "@/utils/tools";
import { getToken } from "@/utils/cookie";
import { Base64 } from "js-base64";
export default {
  name: "detail",
  props: {},
  components: {},
  data() {
    return {
      userinfo: {},
      baseinfo: {},
      radio: "",
      columns: [],
      option: [],
      id: "",
      depament: {},
      readonly: true,
      fileListOne: [],
      fileListTwo: [],
      flagExcel: false,
      flagPpt: false,
      columnsNate: [],
      lookExcelName: "",
      lookPPTName: "",
      disabledBtn: []
    };
  },
  created() {},
  mounted() {
    this.getDepament();
    this.getList();
    this.getType();
  },
  methods: {
    // 获取标准
    getType() {
      const params = new FormData();
      params.append("type", "nominStandard");
      api.queryByType(params).then(data => {
        // this.columnsNate = data.data
        data.data.forEach(item => {
          this.columnsNate.push({ text: item.value, value: item.id });
        });
      });
    },
    // 获取部门
    changeDepament() {
      // if (!this.readonly) {
      if (!(this.disabledBtn?.includes(true) ? false : true)) {
        this.$router.push({
          path: "/mobile/medal/depament",
          query: {
            id: this.userinfo.nominDept
          }
        });
      }
    },
    // 比较数据是否相同
    diff() {
      if (
        this.userinfo.nominee == this.baseinfo.nominee &&
        this.userinfo.nominDept == this.baseinfo.nominDept &&
        this.userinfo.nominType == this.baseinfo.nominType &&
        this.userinfo.nominated == this.baseinfo.nominated &&
        this.userinfo.achievement == this.baseinfo.achievement &&
        this.userinfo.deedRemark == this.baseinfo.deedRemark &&
        this.userinfo.nominStandard == this.baseinfo.nominStandard &&
        this.userinfo.recommendation == this.baseinfo.recommendation &&
        this.userinfo.pptId == this.baseinfo.pptId &&
        this.userinfo.excelId == this.baseinfo.excelId
      ) {
        return true;
      } else {
        return false;
      }
    },
    // 获取详情
    getList() {
      this.id = this.$route.query.id;
      api.queryMedalTaskDetailById({ id: this.id }).then(data => {
        this.userinfo = data.data;
        this.disabledBtn = data.data.approveList.map(item => {
          return item.approveState.includes("3")||item.approveState.includes("驳回") ? true : false;
        });
        console.log("this.disabledBtn", this.disabledBtn);
        (this.lookExcelName = data.data.excelName),
          (this.lookPPTName = data.data.pptxName);
        this.baseinfo = JSON.parse(JSON.stringify(data.data));
        this.depament = this.$store.state.infoDepament;
        this.fileListOne.push({ name: data.data.pptxName });
        this.fileListTwo.push({ name: data.data.excelName });
        if (getToken() == this.userinfo.empNo) {
          this.readonly = false;
        }
        if (this.depament.length > 0) {
          let str = [];
          let arr = [];
          this.depament.forEach(item => {
            str.push(item.id);
            arr.push(item.departmentName);
            this.userinfo.nominDept = str.join(",");
            this.userinfo.nominDeptStr = arr.join(",");
            this.baseinfo.nominDept = str.join(",");
            this.baseinfo.nominDeptStr = arr.join(",");
          });
        }
      });
    },
    // 下载
    onDownPpt() {
      api.downPptx().then(data => {
        downloadExcel(data, "荣誉勋章评选汇报PPT", "ppt");
      });
    },
    // 下载
    onDownExcel() {
      api.downExcel().then(data => {
        downloadExcel(data, "荣誉勋章评选汇报excel", "xlsx");
      });
    },
    // 导出
    down() {
      const arr = this.diff();
      console.log(arr);
      if (arr) {
        api.downPdf({ id: this.id }).then(data => {
          downloadExcel(data, this.userinfo.title, "zip");
        });
      } else {
        this.$dialog
          .confirm({
            message: "编辑未保存，确认导出吗？"
          })
          .then(() => {
            api.downPdf({ id: this.id }).then(data => {
              downloadExcel(data, this.userinfo.title, "zip");
            });
          })
          .catch(() => {});
      }
    },
    // 上传
    afterOne(file) {
      this.lookPPTName = file.file.name;
      if (this.fileListOne.length > 0) {
        this.$message({
          type: "warning",
          message: "只能上传一个ppt",
          duration: 1000
        });
      } else {
        const files = [file];
        let params = new FormData();
        params.append("file", files[0].file);
        this.fileListOne.push({ name: file.file.name });
        this.flagPpt = true;
        api.uploadNew(params).then(data => {
          this.userinfo.pptId = data.data.id;
          this.flagPpt = false;
        });
      }
    },
    // 上传
    afterTwo(file) {
      this.lookExcelName = file.file.name;
      if (this.fileListTwo.length > 0) {
        this.$message({
          type: "warning",
          message: "只能上传一个excel",
          duration: 1000
        });
      } else {
        const files = [file];
        let params = new FormData();
        params.append("file", files[0].file);
        this.fileListTwo.push({ name: file.file.name });
        this.flagExcel = true;
        api.uploadNew(params).then(data => {
          this.userinfo.excelId = data.data.id;
          this.flagExcel = false;
        });
      }
    },
    // 删除
    closeFileOne() {
      this.fileListOne = [];
    },
    // 删除
    closeFileTwo() {
      this.fileListTwo = [];
    },
    // 查看ppt
    lookPPT() {
      // const src = `https://view.xdocin.com/view?src=https://qw.nvc-lighting.com.cn:8082/file/view/${this.userinfo.pptId}`;
      // window.open(src, "_target");

      let pptName = this.lookPPTName.replace(/&|=|\?|\\/g, "");
      var url = `http://qw.nvc-lighting.com.cn:8083/file/view/${this.userinfo.pptId}?fullfilename=${this.userinfo.pptId}${pptName}`; //要预览文件的访问地址
      window.open(
        "http://qw.nvc-lighting.com.cn:10000/onlinePreview?url=" +
          encodeURIComponent(Base64.encode(url))
      );
    },
    // 查看excel
    lookExcel() {
      // const src = `https://view.xdocin.com/view?src=https://qw.nvc-lighting.com.cn:8082/file/view/${this.userinfo.excelId}`;
      // window.open(src, "_target");
      let pptName = this.lookExcelName.replace(/&|=|\?|\\/g, "");
      var url = `http://qw.nvc-lighting.com.cn:8083/file/view/${this.userinfo.excelId}?fullfilename=${this.userinfo.excelId}${pptName}`; //要预览文件的访问地址
      window.open(
        "http://qw.nvc-lighting.com.cn:10000/onlinePreview?url=" +
          encodeURIComponent(Base64.encode(url))
      );
    },
    // 提交
    submit() {
      api.addOrUpdate({ ...this.userinfo }).then(data => {
        console.log(data);
        this.$message({
          type: "success",
          message: "编辑成功",
          duration: 1000
        });
        this.getList();
        this.$router.go(-1);
      });
    },
    // 返回
    toUrl() {
      const arr = this.diff();
      if (arr) {
        this.$router.go(-1);
      } else {
        this.$dialog
          .confirm({
            message: "编辑未保存，确认取消吗？"
          })
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => {});
      }
    },
    // 获取部门
    getDepament() {
      api.findListByName({ departmentName: "" }).then(data => {
        this.columns = data.data;
        this.option = data.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  min-height: 100vh;
  .log {
    height: 200px;
    background: #fff;
    text-align: center;
    img {
      width: 350px;
      height: 55px;
      margin: 40px 0 10px 0;
    }
    p {
      font-size: 32px;
      font-weight: 550;
    }
  }
  .user_form,
  .user_one,
  .user_two,
  .user_three,
  .user_footer {
    height: 400px;
    background: #fff;
    margin-top: 20px;
    padding: 25px;
    display: flex;
    flex-direction: column;
    .title {
      color: rgba(150, 155, 158, 1);
      font-size: 30px;
    }
    ::v-deep {
      .el-textarea__inner {
        height: 285px;
        background: rgba(247, 249, 250, 1);
        border: none;
        border-radius: 20px;
        margin-top: 15px;
      }
    }
  }
  .user_one {
    height: 260px;
    background: none;
    margin-top: 0;
    .concent {
      flex: 1;
      font-size: 28px;
      padding: 0px;
      background: none;
      color: rgba(150, 155, 158, 1);
    }
  }
  .user_form {
    p {
      font-size: 34px;
      text-align: center;
      margin-bottom: 15px;
    }
    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f6f6f6;
      height: 75px;
      font-size: 30px;
      color: rgb(117, 119, 121);
      padding-left: 20px;
    }
    ::v-deep {
      .van-radio__icon--checked .van-icon {
        color: #fff;
        background: rgba(0, 135, 84, 1);
        border: none;
      }
      .van-icon {
        border-radius: 10px;
      }
      .el-input__inner {
        border: none;
      }
      .el-input {
        width: 270px;
        font-size: 28px;
      }
    }
  }
  .user_checkout {
    // height: 300px;
    background: #fff;
    margin-top: 20px;
    padding: 25px;
    .title {
      color: rgba(150, 155, 158, 1);
      font-size: 30px;
    }
    ::v-deep {
      .van-radio__icon {
        color: #fff;
        background: #fff;
      }
      .van-radio__icon--checked .van-icon {
        background: rgba(0, 135, 84, 1);
        border: #ccc;
        color: #fff;
      }
      .van-radio__label {
        font-size: 30px;
      }
      .van-radio {
        margin: 30px 0;
      }
    }
  }
  .menu {
    position: fixed;
    right: 0;
    top: 80%;
    img {
      width: 150px;
      height: 150px;
    }
  }
  .foot-btn {
    height: 120px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    .van-button {
      margin: 0 20px;
      border-radius: 15px;
      width: 320px;
    }
  }
}
.from {
  background: #fff;
  margin-top: 7px * $zoom;
  padding: 25px;
  ::v-deep .el-form-item__label {
    font-size: 11px * $zoom !important;
    color: rgba(150, 155, 158, 1) !important;
  }
  .download {
    // display: flex;
    // align-items: center;
    ::v-deep .el-form-item__content {
      line-height: 15px;
    }
    ::v-deep .el-form-item__label {
      margin-top: -8px;
    }
    div {
      display: flex;
      align-items: center;
      margin-left: 70px;
      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
      span {
        font-size: 30px;
        color: rgba(78, 162, 124, 1);
        // margin-left: 450px;
        display: flex;
        align-items: center;
        margin-right: 10px * $zoom;
        line-height: 40px;
      }
    }
  }
}
.leading {
  div {
    display: flex;
    align-items: center;
  }
  ::v-deep {
    .van-button--primary {
      background: #fff;
      color: rgba(78, 162, 124, 1);
      border: 1px solid rgba(78, 162, 124, 1);
      border-radius: 10px;
      height: 70px;
      // float: left;
      width: 260px;
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
  .leadingSpan {
    // float: right;
    // margin-top: 25px;
    margin-left: 40px;
    i {
      margin-left: 10px;
    }
    .a {
      color: skyblue;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.container_item {
  background: #fff;
  margin-top: 20px;
  padding: 25px;
  .title {
    color: rgba(150, 155, 158, 1);
    font-size: 30px;
  }

  .handle {
    display: flex;
    margin-top: 10px;
    &:last-child {
      .handleDiv::after {
        width: 0;
        height: 0;
      }
    }
    .handleDiv::after {
      display: block;
      content: "";
      width: 1px;
      height: 70px;
      background-color: #ccc;
      position: relative;
      left: 24px;
    }

    .handleRight {
      margin-left: 20px;
      width: calc(100vh);
      .rightTitle {
        margin: 10px 0;
        font-size: 29px;
      }
      .approver {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        .approverImg {
          display: flex;
          flex-shrink: 0;
          align-items: center;
          .iconWrapper {
            position: relative;
            .elIcon {
              position: absolute;
              left: 40px;
              top: -10px;
              font-size: 22px;
            }
          }
          .clr-span {
            display: inline-block;
            border-radius: 20px;
            background-color: rgb(248 250 251);
            margin: 0 5px;
            padding: 10px 0;
            font-size: 24px;
            text-align: center;
            margin-left: 15px;
          }
        }
        .right {
          flex-shrink: 0;
          // margin-left: 30%;
          font-size: 22px;
          color: #9fa2a5;
        }
      }
    }
  }
}
</style>
